/* ============================================================
   BEO - construction de la requete de recherche (2026-10-31).

   Un seul endroit pour transformer ce que la cliente tape en requete
   Shopify. Avant, trois copies (scopeTitle et scopeTitleTyping dans
   beo-app-search-bridge.js, scoped dans beo-app-search.js) avaient
   diverge : le site et l'app ne cherchaient pas pareil.

   Regles, mesurees sur boneato.hk le 31/10 :
   1. Mot fini -> title:mot. La recherche large ramene 177 produits sur
      212 pour " cheese " (descriptions + produits voisins).
   2. Mot de rayon (cheese, fish...) -> (title:mot OR tag:"cat:..."). Le
      titre seul rate le rayon : " cheese " = 1 produit (Comte Cheese)
      alors que les 23 fromages portent cat:cheese ; " fish " = 2 au lieu
      de 30. tag: ne trouve qu'un tag EXACT (tag:cheese = 0), d'ou le
      dictionnaire RAYONS ci-dessous.
   3. Dernier mot pendant la frappe -> mot* (sauf mot de rayon complet,
      traite comme en 2) : sans etoile, Shopify ne
      complete " bri " qu'en " brick " et perd le Brie (" mor " perd le
      Morbier, " toma " les tomates). L'etoile complete tout, mais cherche
      aussi dans les descriptions : snippets/beo-search-match.liquid ne
      garde ensuite que les produits dont un mot du TITRE commence par le
      prefixe, ou qui portent un tag du rayon demande.
   4. Chinois -> jamais cible (titres en anglais, nom chinois dans
      beo.subtitle, que seule la recherche large atteint).
   5. Requete qui contient deja " : " -> envoyee telle quelle.

   Charge avant beo-app-ux.js, beo-app-search-bridge.js, beo-app-pages.js
   (sections/beo-seo-schema.liquid) et beo-app-search.js, qui s'en servent.
   ============================================================ */
(function () {
  "use strict";

  var CJK = /[㐀-鿿豈-﫿]/;

  /* Mot tape -> tags du rayon (cat:/subcat: du catalogue publie au 31/10).
     Seulement les mots qui designent un RAYON et manquent dans les titres.
     Un tag renomme ne casse rien : le mot retombe sur le titre seul. */
  var RAYONS = {
    "cheese": ["cat:cheese"], "cheeses": ["cat:cheese"], "fromage": ["cat:cheese"],
    "dairy": ["cat:cheese"],
    "fish": ["subcat:fillet-whole"],
    "seafood": ["cat:seafood"],
    "shellfish": ["subcat:shellfish"],
    "meat": ["cat:meat"], "meats": ["cat:meat"],
    "beef": ["subcat:beef"], "lamb": ["subcat:lamb"], "pork": ["subcat:pork"],
    "veal": ["subcat:veal-game"], "game": ["subcat:veal-game"],
    "charcuterie": ["subcat:deli-charcuterie"], "deli": ["subcat:deli-charcuterie"],
    "vegetable": ["subcat:vegetables"], "vegetables": ["subcat:vegetables"],
    "veg": ["subcat:vegetables"], "veggie": ["subcat:vegetables"], "veggies": ["subcat:vegetables"],
    "fruit": ["subcat:fruits"], "fruits": ["subcat:fruits"],
    "bakery": ["cat:bakery"],
    "bread": ["subcat:bread-pastries"], "pastry": ["subcat:bread-pastries"],
    "pastries": ["subcat:bread-pastries"], "viennoiserie": ["subcat:bread-pastries"],
    "cake": ["subcat:cakes-desserts"], "cakes": ["subcat:cakes-desserts"],
    "dessert": ["subcat:cakes-desserts"], "desserts": ["subcat:cakes-desserts"],
    "pasta": ["subcat:pasta"],
    "drink": ["cat:drinks"], "drinks": ["cat:drinks"],
    "beverage": ["cat:drinks"], "beverages": ["cat:drinks"],
    "juice": ["subcat:juice"], "juices": ["subcat:juice"],
    "kids": ["cat:kids"], "baby": ["subcat:baby-food"],
    "sweets": ["subcat:jams-chocolate-sweets"],
    "spice": ["subcat:sauces-spices"], "spices": ["subcat:sauces-spices"],
    "condiment": ["subcat:sauces-spices"], "condiments": ["subcat:sauces-spices"],
    "antipasti": ["subcat:antipasti"],
    "grains": ["subcat:grains-pulses"], "pulses": ["subcat:grains-pulses"],
    "legumes": ["subcat:grains-pulses"],
    "pantry": ["cat:pantry"], "grocery": ["cat:pantry"], "groceries": ["cat:pantry"],
    "healthy": ["subcat:healthy"]
  };

  function rayonTags(word, prefix) {
    var tags = [];
    function add(list) {
      list.forEach(function (t) { if (tags.indexOf(t) === -1) tags.push(t); });
    }
    if (RAYONS.hasOwnProperty(word)) add(RAYONS[word]);
    // pendant la frappe, " chee " ouvre deja le rayon fromage (3 lettres minimum)
    if (prefix && word.length >= 3) {
      Object.keys(RAYONS).forEach(function (k) {
        if (k.indexOf(word) === 0) add(RAYONS[k]);
      });
    }
    return tags;
  }

  function group(head, tags) {
    if (!tags.length) return head;
    return "(" + [head].concat(tags.map(function (t) { return 'tag:"' + t + '"'; })).join(" OR ") + ")";
  }

  // Les caracteres de syntaxe tapes par la cliente casseraient la requete.
  function words(term) {
    return String(term || "").toLowerCase().split(/\s+/).map(function (w) {
      return w.replace(/[()"\\*]/g, "");
    }).filter(Boolean);
  }

  function untouched(term) {
    var t = String(term || "").trim();
    return !t || t.indexOf(":") !== -1 || CJK.test(t);
  }

  // Recherche validee (Entree, " See all ", page de resultats) : tous les mots sont finis.
  function scoped(term) {
    if (untouched(term)) return String(term || "").trim();
    return words(term).map(function (w) {
      return group("title:" + w, rayonTags(w, false));
    }).join(" ");
  }

  // Suggestions pendant la frappe : le dernier mot est un debut de mot.
  function typing(term) {
    if (untouched(term)) return String(term || "").trim();
    var w = words(term);
    if (!w.length) return "";
    var last = w.pop();
    // Mot de rayon complet (" cheese ") : forme finie, sans etoile. L'etoile
    // ramenait les descriptions, qui prenaient des places dans les 8 a 10
    // suggestions (4 fromages au lieu de 8 dans l'app).
    var tail = RAYONS.hasOwnProperty(last)
      ? group("title:" + last, RAYONS[last])
      : group(last + "*", rayonTags(last, true));
    return w.map(function (x) {
      return group("title:" + x, rayonTags(x, false));
    }).concat(tail).join(" ");
  }

  // Requete construite ici -> mot lisible (titre de page, repli sur la recherche large).
  function human(q) {
    return String(q || "")
      .replace(/\s+OR\s+tag:"[^"]*"/g, "")
      .replace(/title:/g, "")
      .replace(/[()*]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function isBuilt(q) {
    q = String(q || "");
    return q.indexOf("title:") !== -1 || q.indexOf('tag:"') !== -1;
  }

  window.BEOSearch = {
    scoped: scoped,
    typing: typing,
    human: human,
    isBuilt: isBuilt
  };
})();
